function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWarningResolved = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    viewBox: "-380 292 30 30",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: -365,
    cy: 307,
    r: 13.143,
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeWidth: 3,
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-356.905 300.198c-6.147 4.715-11.963 10.906-11.963 10.906l-4.572-3.403-1.754 1.801c1.882 1.467 6.27 5.369 7.76 6.838 3.69-6.289 7.613-11.034 11.347-15.382z",
    style: {
      fill: "#39bc0d"
    }
  }));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWarningResolved);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/warningResolved.svg";